<p-dialog
  [(visible)]="popupMessage"
  [modal]="true"
  class="popupMessage"
  [header]="'Modification du message d\'inaccessibilité'"
  [style]="{ width: '100vw', height: '100vh' }"
>
  <div class="content flex justify-content-center">
    <div style="width: 80vw">
      <app-editor2
        [(ngModel)]="disabledMessage"
        [storageId]="programId"
        [style]="{ height: 'calc(100vh - 300px)', width: '100%' }"
      ></app-editor2>
    </div>
  </div>

  <div class="ui-dialog-footer text-center mt-4 flex justify-content-around">
    <p-button (click)="saveMessage()">Enregistrer</p-button>
    <p-button (click)="cancelMessage()">Annuler</p-button>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="popupUpdateMail"
  [modal]="true"
  class="updateMail"
  [header]="'Modification du mail'"
  [style]="{ width: '100vw', height: '100vh' }"
>
  <div class="content flex justify-content-center">
    <div style="width: 80vw">
      <div class="flex flex-column gap-2 mt-6 mb-3">
        <label for="email_label" class="white">Alias du mail (ex: "Secrets du Ballet")</label>
        <input type="email" [(ngModel)]="email.alias" pInputText required />
      </div>
      <div class="flex flex-column gap-2 mt-6 mb-3">
        <label for="email_label" class="white">Sujet du mail</label>
        <input type="email" [(ngModel)]="email.subject" pInputText id="email_label" required />
      </div>

      <div class="mt-3">
        <div class="mb-2">
          <span class="text-red">Templating:</span>
          <span class="bg-gray-500 ml-3">Le lien est ##ici##</span> deviendra dans le mail =>
          <span class="bg-gray-500 ml-3">Le lien est <span class="text-blue-800 underline">ici</span></span>
          <br />
          <span class="text-red">Templating:</span>
          <span class="bg-gray-500 ml-3">NOM_DOMAINE</span> sera remplacé par l'url courante (3etage ou secret)
        </div>
        <app-editor2
          [(ngModel)]="email.content"
          [storageId]="programId"
          [style]="{ height: 'calc(100vh - 600px)', width: '100%' }"
        ></app-editor2>
      </div>
    </div>
  </div>

  <div class="ui-dialog-footer text-center mt-4 flex justify-content-around">
    <p-button (click)="saveMail()">Enregistrer</p-button>
    <p-button (click)="cancelMail()">Annuler</p-button>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="popupPreview"
  [modal]="true"
  class="preview"
  [header]="'Aperçu du programme \'' + currentProgram?.name + '\''"
  [style]="{ width: '100vw', height: '100vh' }"
>
  <div class="content flex justify-content-center">
    <div style="max-width: 500px">
      @for (section of sectionsPreview; track section.id) {
      <div class="section">
        <h1 class="title mb-3" style="color: blueviolet">{{ section?.title }}</h1>
        @for (subSection of section?.subSections; track subSection.id) {
        <app-sub-section [subSection]="subSection"></app-sub-section>
        <div>________________</div>
        }
        <div class="separator2"></div>
      </div>
      }
    </div>
  </div>

  <div class="ui-dialog-footer text-center mt-4">
    <p-button (click)="popupPreview = false">Fermer la section</p-button>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="popupImportTheme"
  [modal]="true"
  [header]="'Import du thème'"
  [style]="{ width: '600px', height: '250px' }"
>
  <div class="content flex justify-content-center">
    <p-dropdown
      [(ngModel)]="currentThemingImportId"
      [options]="themingPrograms"
      placeholder="Selectionner un programme"
      optionValue="id"
      optionLabel="label"
      appendTo="body"
    >
    </p-dropdown>
  </div>

  <div class="ui-dialog-footer text-center mt-4">
    <p-button (click)="importTheme()">Importer le thème</p-button>
  </div>
</p-dialog>

<div class="g_title mt-3 mb-3 text-center relative">
  <span
    >Programme <small class="font-italic">({{ currentProgram?.name || "Création..." }} )</small>
    {{ currentProgram?.date || "" }}</span
  >
  <i [routerLink]="'/admin'" class="cursor-pointer absolute pi pi-arrow-left ml-auto" style="left: 0; top: 10px"></i>
</div>

<div class="container">
  <p-tabView [(activeIndex)]="activeIndex" (activeIndexChange)="changeActive()">
    <!--    GENERAL-->
    <p-tabPanel header="Général">
      <div class="scroller_container">
        <form [formGroup]="fg">
          @if (!programId) { } @else if (currentProgram?.accessible) {
          <div style="color: limegreen" class="mb-2 mt-2">La programme est actuellement accessible à tous.</div>
          <div class="flex align-items-center">
            <p-button (click)="changeAccessibleAndPublish(false)">
              <b><span style="color: red">Rendre inaccessible</span>&nbsp;et publier</b>
            </p-button>
            <div class="ml-4 cursor-pointer" (click)="popupMessage = true">
              <i class="pi pi-pencil text-xs mr-2"></i>Modifier le message d'inaccessibilité
              <span class="text-gray-400 mr-2">(il faudra ensuite publier les modifs)</span>
            </div>
          </div>
          } @else {
          <div style="color: red" class="mb-2">Le programme est actuellement inaccessible.</div>
          <div class="flex align-items-center">
            <p-button (click)="changeAccessibleAndPublish(true)">
              <b><span style="color: darkgreen">Rendre accessible</span>&nbsp; et publier</b>
            </p-button>
            <div class="ml-4 cursor-pointer" (click)="popupMessage = true">
              <i class="pi pi-pencil text-xs mr-2"></i>Modifier le message d'inaccessibilité
              <span class="text-gray-400 mr-2">(il faudra ensuite publier les modifs)</span>
            </div>
          </div>
          }

          <div class="flex flex-column gap-2 mb-3 mt-3">
            <label for="name">Nom * (Alias: {{ currentProgram?.alias || "-" }})</label>
            <input formControlName="name" required pInputText id="name" />
          </div>

          <div class="flex flex-column gap-2 mb-3">
            <label for="date">Date *</label>
            <input formControlName="date" pInputText id="date" />
          </div>

          <div class="flex flex-column gap-2 mb-4">
            <label for="town">Ville *</label>
            <input formControlName="town" pInputText id="town" />
          </div>

          <div class="mb-4 flex align-items-center">
            @if (programId) {
            <p-button label="Modifier le mail" (click)="popupUpdateMail = true"></p-button>
            }
            <span class="text-xs ml-4">(pas besoin de publier le programme pour que cela soit pris en compte)</span>
          </div>
        </form>
        <div class="g_title flex align-items-center mb-3">
          INTRO
          <i
            title="Modifier l'introduction"
            class="pi pi-pencil ml-auto cursor-pointer"
            (click)="openSubSectionDetails(introductionId || '')"
          ></i>
        </div>
        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 10px">
          <p-dropdown
            [options]="allSubsections"
            [(ngModel)]="introductionId"
            appendTo="body"
            (ngModelChange)="introductionIdChange()"
            optionValue="id"
            optionLabel="title_internal"
            styleClass="w-full"
            [showClear]="true"
            [filter]="true"
            filterBy="title_internal"
            placeholder="Selectionner une page"
          ></p-dropdown>
          <p-dropdown
            [options]="allVersions"
            [(ngModel)]="introductionVersionId"
            appendTo="body"
            optionValue="id"
            optionLabel="title"
            styleClass="w-full"
            [showClear]="true"
            [filter]="true"
            filterBy="title"
            placeholder="Selectionner une version"
          ></p-dropdown>
        </div>

        <!--THEMING-->
        @if (currentProgram && currentProgram.theming) {
        <div class="g_title flex align-items-center mb-3 mt-3">
          THEME
          <button pButton class="ml-6" label="Importer" (click)="popupImportTheme = true"></button>
        </div>
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-gap: 10px">
          <div class="flex align-items-center">
            <div class="mr-2">Background Color</div>
            <input required pInputText [(ngModel)]="currentProgram.theming.bgColor" />
          </div>
          <div class="flex align-items-center">
            <div class="mr-2">Menu background Color</div>
            <input required pInputText [(ngModel)]="currentProgram.theming.menuBgColor" />
          </div>
          <div class="flex align-items-center">
            <div class="mr-2">Font Color</div>
            <input required pInputText [(ngModel)]="currentProgram.theming.textColor" />
          </div>
          <div class="flex align-items-center">
            <p-fileUpload
              mode="basic"
              [auto]="true"
              accept=".mp4,image/*"
              [maxFileSize]="9000000"
              [customUpload]="true"
              (uploadHandler)="onUpload($event, 'logo')"
              chooseLabel="Logo"
              class="primary"
            />
            @if (currentProgram.theming.logoSrc) {
            <i
              title="Supprimer le logo"
              class="cursor-pointer pi pi-trash ml-4 mr-2"
              (click)="currentProgram.theming.logoSrc = ''"
            ></i>
            <img class="ml-4" style="height: 50px; width: auto" [src]="currentProgram.theming.logoSrc" />
            }
          </div>
          <div class="flex align-items-center">
            <p-fileUpload
              mode="basic"
              [auto]="true"
              accept=".mp4,image/*"
              [maxFileSize]="9000000"
              [customUpload]="true"
              (uploadHandler)="onUpload($event, 'footer')"
              chooseLabel="Footer"
              class="primary"
            />
            @if (currentProgram.theming.footerSrc) {
            <i
              title="Supprimer le footer"
              class="cursor-pointer pi pi-trash ml-4 mr-2"
              (click)="currentProgram.theming.footerSrc = ''"
            ></i>
            <img class="ml-4" style="height: 50px; width: auto" [src]="currentProgram.theming.footerSrc" />
            }
          </div>
        </div>
        }

        <div class="font-italic mt-8">
          @if (!published_date) {
          <span class="">Programme non publié</span>
          } @else { Programme publié le {{ published_date | date : "dd MMM yyyy 'à' HH:mm:ss" }}
          }
        </div>
      </div>
    </p-tabPanel>

    @if (programId) {
    <!--SECTIONS-->
    <p-tabPanel header="Sections">
      <div class="scroller_container">
        <div class="g_title mt-2 flex align-items-center mb-3 cursor-pointer">
          SECTIONS
          <i title="Ajouter une section" class="pi pi-plus ml-4" (click)="addSection()"></i>
          <div class="ml-auto">
            <i title="Ajouter une section" class="pi pi-eye mr-6" (click)="updatePreview(); popupPreview = true"></i>
            <i title="Tout étandre" class="pi pi-angle-double-down mr-4" (click)="expandAll(true)"></i>
            <i title="Tout réduire" class="pi pi-angle-double-up" (click)="expandAll(false)"></i>
          </div>
        </div>
        @for (section of currentProgram?.sections; track section.id) {
        <app-admin-section
          #section
          [style]="'opacity:' + (section.removing ? 0 : 1)"
          [subSections]="allSubsections"
          (onSubsectionUpdated)="updateMapSubsections($event)"
          (onMove)="moveSection($event, section.id || '')"
          (onDelete)="deleteSection(section.id || '')"
          [section]="section"
        ></app-admin-section>
        }
      </div>
    </p-tabPanel>

    <!--    SUB-SECTIONS-->
    <p-tabPanel header="Pages">
      <div class="scroller_container">
        <!--list items are updated when this tab becomes active (without the if, could be out-dated!)-->
        @if (activeIndex == 2) {
        <app-admin-list-subsections></app-admin-list-subsections>
        }
      </div>
    </p-tabPanel>

    <p-tabPanel header="Réferentiel" class="tabPanel-referentiel">
      <div class="scroller_container">
        <app-referential-list></app-referential-list>
      </div>
    </p-tabPanel>

    <!--    IMAGES-->
    <!--    <p-tabPanel header="Gestion des images">-->
    <!--      <div class="scroller_container">-->
    <!--        <p-fileUpload-->
    <!--          mode="basic"-->
    <!--          [auto]="true"-->
    <!--          accept=".mp4,image/*"-->
    <!--          [maxFileSize]="1000000"-->
    <!--          [customUpload]="true"-->
    <!--          (uploadHandler)="onUpload($event)"-->
    <!--          chooseLabel="Uploader une image"-->
    <!--          class="primary"-->
    <!--        />-->

    <!--        <h3>Images du programmes:</h3>-->
    <!--        <div class="flex align-items-center">-->
    <!--          @for (image of images; track image.name) {-->
    <!--            <div class="mr-2">-->
    <!--              <img style="width: 100px; height: auto" [src]="image.src"/>-->
    <!--              <div class="font-italic">{{ image.name }}</div>-->
    <!--            </div>-->
    <!--          }-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </p-tabPanel>-->
    }
  </p-tabView>

  @if (!loading) {
  <div class="text-center mt-6 flex justify-content-around">
    <p-button
      severity="secondary"
      [label]="(currentProgram?.id ? 'Enregistrer ' : 'Créer ') + ' (sans publier)'"
      (click)="save()"
    ></p-button>
    @if (currentProgram?.id) { @if (published_date) {
    <a target="_blank" [href]="'/program/' + currentProgram?.id">
      <p-button label="Aperçu (de la dernière version publiée)"></p-button>
    </a>
    }
    <p-button label="Enregistrer et publier" (click)="publish()"></p-button>
    }
  </div>
  } @else {
  <div class="text-center mt-6 flex justify-content-around">
    <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
  </div>
  }
</div>
